module.exports = __webpack_public_path__ + "media/images/review/ico-crown-2-255e9ee3cb49cff4e34e325d0c035906.svg";